export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/minmax.worker.30a5b4f3.worker.js");
}
